import React from 'react';
import { compose } from 'redux';
import { withFormik } from 'formik';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { noop } from 'lodash';
import classNames from 'classnames';
import { any, func, objectOf, string, bool } from 'prop-types';
import Input from '../Input/Input';
import { CONSTS } from './consts';
import { inputDateSchema } from './validate';
import s from './index.css';

class InputDate extends React.Component {
  static propTypes = {
    touched: objectOf(any),
    values: objectOf(any),
    handleChange: func,
    errors: objectOf(any),
    setFieldValue: func,
    handleBlur: func,
    errMess: string,
    className: string,
    required: bool,
    onChangeParent: func,
    type: string,
  };

  static defaultProps = {
    handleChange: noop,
    setFieldValue: noop,
    handleBlur: noop,
    onChangeParent: noop,
    touched: {},
    values: {},
    errors: {},
    errMess: '',
    className: '',
    required: false,
    type: noop,
  };

  onBlur = name => e => {
    const { setFieldValue, handleBlur } = this.props;
    setFieldValue(name, e.target.value.trim());
    handleBlur(e);
  };

  onChange = name => async e => {
    const { handleChange, onChangeParent, values } = this.props;
    const mergeValues = { ...values, [name]: e.target.value };
    const { day, month, year } = mergeValues;
    handleChange(e);
    CONSTS.SEND_GA(CONSTS.CTA_EDIT, name);
    if (!day || !month || !year) {
      return;
    }
    const YYYYMMDD = `${year}-${this.minTwoDigits(month)}-${this.minTwoDigits(
      day,
    )}`;
    onChangeParent(YYYYMMDD);
  };

  preNumberFormat = (v = '') => v && `${v}`.replace(/\./g, '').trim();

  minTwoDigits = n => (Number(n) < 10 ? '0' : '') + Number(n);

  requireLabel = label => (this.props.required ? `${label} (*)` : label);

  render() {
    const {
      touched,
      values,
      handleBlur,
      errors,
      errMess,
      className,
      type,
    } = this.props;
    return (
      <React.Fragment>
        <div className="container">
          <div className={classNames('row', s.lblHeader)}>
            {CONSTS.LBL_HEADER}
          </div>
          <div className={classNames(s.wrapper, 'row')}>
            <Input
              type={type}
              isNumber
              require
              preFormat={this.preNumberFormat}
              touched={touched}
              onChange={this.onChange(CONSTS.DAY.KEY)}
              onBlur={handleBlur}
              value={values?.day}
              name={CONSTS.DAY.KEY}
              placeholder={this.requireLabel(CONSTS.DAY.LABEL)}
              errorMsg={touched?.day && errors?.day}
              popoverPosition={CONSTS.POPOVER_POSITION}
              autoComplete={false}
              className={classNames(className, s.customInput)}
              touch={() => CONSTS.SEND_GA(CONSTS.CTA_TAP, CONSTS.DAY.KEY)}
            />
            <div className={s.separate} />
            <Input
              type={type}
              isNumber
              preFormat={this.preNumberFormat}
              require
              touched={touched}
              onChange={this.onChange(CONSTS.MONTH.KEY)}
              onBlur={handleBlur}
              value={values.month}
              name={CONSTS.MONTH.KEY}
              placeholder={this.requireLabel(CONSTS.MONTH.LABEL)}
              errorMsg={touched?.month && errors?.month}
              popoverPosition={CONSTS.POPOVER_POSITION}
              className={classNames(className, s.customInput)}
              touch={() => CONSTS.SEND_GA(CONSTS.CTA_TAP, CONSTS.MONTH.KEY)}
            />
            <div className={s.separate} />
            <Input
              type={type}
              isNumber
              require
              preFormat={this.preNumberFormat}
              touched={touched}
              onChange={this.onChange(CONSTS.YEAR.KEY)}
              onBlur={handleBlur}
              value={values.year}
              name={CONSTS.YEAR.KEY}
              placeholder={this.requireLabel(CONSTS.YEAR.LABEL)}
              errorMsg={touched?.year && errors?.year}
              popoverPosition={CONSTS.POPOVER_POSITION}
              className={classNames(className, s.customInput)}
              touch={() => CONSTS.SEND_GA(CONSTS.CTA_TAP, CONSTS.YEAR.KEY)}
            />
          </div>
        </div>
        {errMess && <div className={s.errMess}>{errMess} </div>}
      </React.Fragment>
    );
  }
}

const enhance = compose(
  withFormik({
    enableReinitialize: true,
    isInitialValid: true,
    validationSchema: inputDateSchema,
    mapPropsToValues: props => {
      const { initialValues } = props;
      const { day = '', month = '', year = '' } = initialValues || {};
      return {
        day,
        month,
        year,
      };
    },
  }),
  withStyles(s),
);
export default enhance(InputDate);
